import { Stack, Typography } from '@mui/material';
import Modal from 'components/v2/modal/Modal';
import { MODAL_ID, MODALS_STORE } from 'constants/ui/modal';
import { MODAL_WIDTH } from 'constants/ui/style';

const NewsModal = () => {
  const { toggleModal, isModalOpen, getModalData } = MODALS_STORE.news();
  const content = getModalData(MODAL_ID.NEWS)?.content ?? '';
  const date = getModalData(MODAL_ID.NEWS)?.date ?? '';
  const title = getModalData(MODAL_ID.NEWS)?.title ?? '';

  return (
    <Modal
      isOpen={isModalOpen(MODAL_ID.NEWS)}
      toggleModal={() => toggleModal(MODAL_ID.NEWS)}
      modalTitle={
        <Stack>
          <Typography variant="h5">{title}</Typography>
          <Typography variant="caption">{date}</Typography>
        </Stack>
      }
      width={MODAL_WIDTH.md}
      hideFooter
    >
      <Stack gap={2}>
        <div dangerouslySetInnerHTML={{ __html: content ?? '' }} />
      </Stack>
    </Modal>
  );
};

export default NewsModal;
